import React from 'react';
import { PropTypes } from 'prop-types';
import colors from '@general/colors';
import { useScreenSmDown, useScreenMinMd } from '@hooks/useResponsive';

const getIconDesktop = isActive => {
    const fill = isActive ? colors.primary : '#D3D0D5';
    const stroke = isActive ? '#fff' : '#000';

    return (
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="19.6923" cy="20.0009" r="19.6923" fill={fill} />
            <g clipPath="url(#clip0_4494:77958)">
                <path
                    d="M15.5 18.8086V11.8086H24.5V16.8086"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M18.5 20.8086H12.5V26.8086H18.5V20.8086Z"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M27.5 18.8086H21.5V26.8086H27.5V18.8086Z"
                    stroke={stroke}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path d="M14.5 23.8086H16.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.5 21.8086H25.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M23.5 23.8086H25.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18.5 26.8086H21.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
                <path d="M18.5 14.8086H21.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_4494:77958">
                    <rect width="16" height="16" fill={fill} transform="translate(12 11.3086)" />
                </clipPath>
            </defs>
        </svg>
    );
};

const getIconMobile = isActive => {
    const stroke = isActive ? '#246EFF' : '#1A1A1A';

    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.5 7.5V0.5H12.5V5.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.5 9.5H0.5V15.5H6.5V9.5Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.5 7.5H9.5V15.5H15.5V7.5Z" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M2.5 12.5H4.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.5 10.5H13.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.5 12.5H13.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.5 15.5H9.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.5 3.5H9.5" stroke={stroke} strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

const MenuRetailers = ({ isActive = false }) => {
    const isScreenSmDown = useScreenSmDown();
    const isScreenMinMd = useScreenMinMd();

    return (
        <>
            {isScreenSmDown && getIconMobile(isActive)}
            {isScreenMinMd && getIconDesktop(isActive)}
        </>
    );
};

MenuRetailers.propTypes = {
    isActive: PropTypes.bool,
};

export default MenuRetailers;
